<template>
    <div class="xsc">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="top_banner">
                <div class="back_icon"
                     @click="goBack"></div>
                <img src="./img/share.png"
                     class="share"
                     @click="share"
                     alt=" " />
            </div>
            <div class="text">
                <div class="item">
                    <div class="title"><span>课程列表</span></div>
                    <div class="con">
                        <div class="course"
                             v-for="(item,index) in course_list"
                             :key="index">
                            <div class="name">
                                <img src="./img/jiantou.png"
                                     class="icon" />
                                <span class="index">{{index==0?'':`第${index}节`}}</span>
                                <span class="course_name">{{item.name}}</span>
                            </div>
                            <span class="btn"
                                  @click="play(item)">学习</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="videoPlay"
                     :video_url="video_url"></videoPlayer>
    </div>
</template>
<script>
import loadingS from 'SRC/components/base/loadingS.vue';
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    components: { loadingS, videoPlayer },
    data () {
        return {
            openStatus: false,
            loading: true,
            videoPlay: false,
            video_url: "",
            course_list: []
        }
    },
    created () {
        document.title = '小升初专题课';
        this.getData()
    },
    methods: {
        share () {
            let school_id = JSON.parse(localStorage.getItem('info')).units[0].school_id;
            let url = WAP_URL + "/qr/com_special?code_id=" + school_id + "&open_code=3694&hd_type=12"
            if (this.inApp) {
                this.appFunction("ys_share", `小升初专题课,点击开始学习小升初专题课,${url}`, 1);
            } else {
                let that = this
                let coptText = '小升初专题课，点击开始学习小升初专题课。链接：' + url
                this.copyVisible = true;
                layer.alert('将链接分享到对应的班级群，点击链接即可开始学习小升初专题课。', 'tea', function (index) {
                    that.copyText(coptText);
                    layer.close(index)
                }, '分享链接复制成功')
            }
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        goBack () {
            this.$router.go(-1);
        },
        getData () {
            this.$http.get(API_URL_HD_API + '/xsc2024/course/').then((data) => {
                data = data.data;
                if (data.response === 'ok') {
                    this.course_list = data.data;
                } else {
                    layer.tips(data.message);
                }

            })
            this.loading = false
        },
        play (course) {
            let url = course.video_url
            if (this.inApp) {
                if (url) this.appFunction("ys_video", `${url},1`);
            } else {
                this.h5play(url);
            }
        },
        h5play (url) {
            if (url) {
                this.video_url = url;
                this.videoPlay = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },
        closePlayer () {
            this.videoPlay = false;
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.xsc {
    min-height: 100vh;
    background-color: #6d94f7;
    padding-bottom: 10px / $ppr;
    .top_banner {
        height: 1260px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/banner2.png");
        position: relative;
        .back_icon {
            position: absolute;
            width: 56px / $ppr;
            height: 56px / $ppr;
            background-position: 50%;
            background-size: 56px / $ppr 56px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/back.png");
            cursor: pointer;
            top: 24px / $ppr;
            left: 24px / $ppr;
        }
        .share {
            position: absolute;
            right: 0;
            top: 285px / $ppr;
            width: 136px / $ppr;
            height: 64px / $ppr;
        }
    }
    .text {
        margin-top: -600px / $ppr;
        padding: 0 36px / $ppr;
        position: relative;
        .item {
            border-radius: 30px / $ppr;
            margin-top: 60px / $ppr;
            border: 2px / $ppr solid #fff;
            background-color: #d2eaff;
            background: -o-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -ms-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -moz-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -webkit-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            .title {
                text-align: center;
                padding: 24px / $ppr 0;
                span {
                    font-size: 42px / $ppr;
                    color: #212c4b;
                    font-weight: bold;
                    position: relative;
                    z-index: 9;
                    &:after {
                        content: "";
                        position: absolute;
                        z-index: -1;
                        bottom: 0;
                        left: 50%;
                        width: 100%;
                        height: 16px / $ppr;
                        border-radius: 16px / $ppr;
                        transform: translateX(-50%);
                        background-color: #9bcaff;
                        background: -o-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -ms-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -moz-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -webkit-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                    }
                }
            }
            .con {
                background: #f1fcff;
                border-radius: 30px / $ppr;
                padding: 0 33px / $ppr;
                .course {
                    padding: 31px / $ppr 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-top: 1px dotted #eaeaea;
                    .name {
                        display: flex;
                        align-items: center;
                        font-size: 28px / $ppr;
                        color: #060609;
                        .icon {
                            width: 14px / $ppr;
                            height: 20px / $ppr;
                            margin-right: 10px / $ppr;
                        }
                        .index {
                            white-space: nowrap;
                            margin-right: 10px / $ppr;
                        }
                        .course_name {
                            max-width: 360px / $ppr;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                    &:first-child {
                        border-top: none;
                    }
                    .btn {
                        width: 108px / $ppr;
                        height: 44px / $ppr;
                        line-height: 50px / $ppr;
                        border-radius: 44px / $ppr;
                        color: #fff;
                        text-align: center;
                        font-size: 24px / $ppr;
                        background-color: #4c66eb;
                        background: -o-linear-gradient(
                            to right,
                            #4c66eb 0%,
                            #6d94f7 100%
                        );
                        background: -ms-linear-gradient(
                            to right,
                            #4c66eb 0%,
                            #6d94f7 100%
                        );
                        background: linear-gradient(
                            to right,
                            #4c66eb 0%,
                            #6d94f7 100%
                        );
                        background: -moz-linear-gradient(
                            to right,
                            #4c66eb 0%,
                            #6d94f7 100%
                        );
                        background: -webkit-linear-gradient(
                            to right,
                            #4c66eb 0%,
                            #6d94f7 100%
                        );
                    }
                }
            }
        }
    }
}
</style>
